import React from "react";
import injectSheet from "react-jss";
import OppsImg from "Assets/images/e-oops.png";
import Logo from "Components/helpers/Logo";

const styleSheet = () => ({
  container: {
    width: "100%",
    height: "100%",
  },
  innerContainer: {
    width: 600,
    margin: "0 auto",
    marginTop: 75,
  },
  offlineMessageContainer: {
    display: "flex",
  },
  heading: {
    fontSize: 22,
    fontWeight: 400,
  },
  logo: {
    background: `url(${OppsImg}) no-repeat right bottom`,
    width: 194,
    height: 237,
  },
  message: {
    fontSize: 14,
  },
  messageContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    marginLeft: 20,
  },
  anchor: {
    display: "flex",
    justifyContent: "flex-end",
  },
  contactUS: {
    textDecoration: "underline",
  },
});

const PageNotFound = ({ classes }) => (
  <div className={classes.container}>
    <div className={classes.innerContainer}>
      <a className={classes.anchor} href="https://www.youvisit.com/">
        <Logo />
      </a>
      <div className={classes.offlineMessageContainer}>
        <div className={classes.logo} />

        <div className={classes.messageContainer}>
          <h1 className={classes.heading}>404. Page Does Not Exist.</h1>
          <p className={classes.message}>
            Looks like you landed on a page that does not exist or is no longer
            available.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default injectSheet(styleSheet)(PageNotFound);
